export { default } from './ConfiguratorNavigation';
